export class GoogleWorkspaceUserMailSelectedItemsOptions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "items",
            "baseName": "items",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "targetMailbox",
            "baseName": "targetMailbox",
            "type": "string",
            "format": ""
        },
        {
            "name": "label",
            "baseName": "label",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreOriginalLabels",
            "baseName": "restoreOriginalLabels",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceUserMailSelectedItemsOptions.attributeTypeMap;
    }
    constructor() {
    }
}
